import { render, staticRenderFns } from "./is_need_smt.vue?vue&type=template&id=18a53a0e&scoped=true"
import script from "./is_need_smt.vue?vue&type=script&lang=js"
export * from "./is_need_smt.vue?vue&type=script&lang=js"
import style0 from "./is_need_smt.vue?vue&type=style&index=0&id=18a53a0e&prod&lang=scss&scoped=true"
import style1 from "./is_need_smt.vue?vue&type=style&index=1&id=18a53a0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a53a0e",
  null
  
)

export default component.exports